import { DATASOURCE_KEY_MAP, SENSORTOWER_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics/keyMap';

import type { ISortableMetricMetadata } from '@intelligence/types/common';

// 可排序的指标核心配置，配置指标的数据源、指标key、指标的name
export const SORTABLE_METRICS_METADATAS_MAPPING: {
  [metric: string]: ISortableMetricMetadata;
} = {
  [SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE]: {
    dataSourceClient: DATASOURCE_KEY_MAP.SENSORTOWER,
    dataSource: DATASOURCE_KEY_MAP.SENSORTOWER,
    metric: SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE,
    name: 'dbi_metric_mobile_cross_usage',
  },
  [SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY]: {
    dataSourceClient: DATASOURCE_KEY_MAP.SENSORTOWER,
    dataSource: DATASOURCE_KEY_MAP.SENSORTOWER,
    metric: SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY,
    name: 'dbi_metric_mobile_cross_affinity',
  },
};

// 可排序指标，宽表根据这个配置 渲染有哪些列，按照这个顺序渲染列
export const SORTABLE_METRICS = [SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE, SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY];
